import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"embercom-prosemirror-composer-horizontal-divider\"><div class=\"embercom-prosemirror-composer-horizontal-divider-inner\"></div></div>", {
  moduleName: "@intercom/composer-ember/components/utils/horizontal-divider.hbs"
});